<template>
  <div class="input-money-wrap">
    <number
      v-if="value.type == 'đ'"
      class="px-2 w-100 input-money-wrap_input"
      @keydown.native="skipDotAndMinusOnly"
      v-model.number="value['đ']"
      v-bind="numFormat"
      @change="() => checkMinMaxValueNumber(value, 'đ', min, max)"
    ></number>
    <input
      type="text"
      step="1"
      v-if="value.type == '%'"
      class="px-2 w-100 input-money-wrap_input"
      @keypress="enterKeyFloat($event)"
      @input="() => checkPercentMixin(value, '%')"
      v-model.number="value['%']"
      :max="100"
      :min="0"
    />
    <el-radio-group size="medium" class="input-money-wrap_type" v-model="value.type">
      <el-radio-button class="mb-0" label="đ"></el-radio-button>
      <el-radio-button class="mb-0" label="%"></el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
import { numFormat } from "../utils/pos"
import enterKeyFloat from "../mixins/pos"

export default {
  props: ["value", "max", "min"],
  mixins: [ enterKeyFloat],
  data() {
    return {
      numFormat: numFormat
    }
  },
  methods: {
    skipDotAndMinusOnly(e) {
      if (e.key == "." || e.key == "-") e.preventDefault();
    },
    checkPercentMixin(parent, key) {
      if (parent[key] > 100) parent[key] = 100;
      if (parent[key] < 0) parent[key] = 0;
      if (parent[key] == "") parent[key] = 0;
    },
    checkMinMaxValueNumber(item, key, minValue, maxValue) {
      if(maxValue || maxValue == 0) {
        if(item[key] > maxValue) item[key] = maxValue
      }
      if(minValue || minValue == 0) {
        if(item[key] < minValue) item[key] = minValue
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.input-money-wrap {
  border: 0.5px solid #ddd;
  position: relative;
  padding: 10px 0;

  &_input {
    padding-right: 109px !important;
  }

  &_type {
    right: 2px;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
  }
}</style>
